module.exports = __webpack_public_path__ + "static/img/place-icon-active.b100f681.svg";